import {PASSWORD_VALIDATION_DIGIT, PASSWORD_VALIDATION_DISALLOWED, PASSWORD_VALIDATION_LENGTH, PASSWORD_VALIDATION_MATCHING, PASSWORD_VALIDATION_NODASHBEGIN, PASSWORD_VALIDATION_SPECIAL, PASSWORD_VALIDATION_UPPER_LOWER} from "../constants/PasswordStrength";

export const validatePassword = (password, passwordRepeat) => {

    let passwordErrors = {};

    if (!password) {
        passwordErrors[PASSWORD_VALIDATION_MATCHING] = true;
        passwordErrors[PASSWORD_VALIDATION_LENGTH] = true;
        passwordErrors[PASSWORD_VALIDATION_UPPER_LOWER] = true;
        passwordErrors[PASSWORD_VALIDATION_DIGIT] = true;
        passwordErrors[PASSWORD_VALIDATION_SPECIAL] = true;
        passwordErrors[PASSWORD_VALIDATION_DISALLOWED] = true;

        return passwordErrors;
    }

    // check match
    if (password !== passwordRepeat) {
        passwordErrors[PASSWORD_VALIDATION_MATCHING] = true;
    }
    // check length > 8
    if (password.length < 12) {
        passwordErrors[PASSWORD_VALIDATION_LENGTH] = true;
    }
    // check upper lower case
    if (!/(?=.*[a-z])(?=.*[A-Z])/.test(password)) {
        passwordErrors[PASSWORD_VALIDATION_UPPER_LOWER] = true;
    }
    // check one digit
    if (!/(?=.*[0-9])/.test(password)) {
        passwordErrors[PASSWORD_VALIDATION_DIGIT] = true;
    }
    // check one specialChar
    if (!/(?=.*[$!#*+,\-.;_:\/])/.test(password)) {
        passwordErrors[PASSWORD_VALIDATION_SPECIAL] = true;
    }
    // check disAllowedChars
    if (/[^$!#*+,\-.;_:\/a-zA-Z0-9]+/.test(password)) {
        passwordErrors[PASSWORD_VALIDATION_DISALLOWED] = true;
    }

    if(password[0] === '-') {
        passwordErrors[PASSWORD_VALIDATION_NODASHBEGIN] = true;
    }

    return passwordErrors;
}



/** WEBPACK FOOTER **
 ** ./src/util/password.js
 **/